<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>

<div class="d-flex justify-content-between">
  <h1 mat-dialog-title>Edit Industry Scenario</h1>
  <div class="actions-container default-padding">
    <button mat-stroked-button id="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="submit-button" (click)="onSubmit()"
            [disabled]="!industryScenarioForm.valid">
      Submit
    </button>
  </div>
</div>


<div mat-dialog-content style="padding-top: unset; max-height:70vh;">
  <form class="d-flex flex-column gap-8" [formGroup]="industryScenarioForm">
    <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
      <mat-label>Enter Scenario</mat-label>
      <input matInput maxlength="25" id="scenario-input" formControlName="updatedScenarioName"
             [(ngModel)]="industryScenario.industryScenarioName"
             value="{{ industryScenario.industryScenarioName }}"/>
    </mat-form-field>
    <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
      <mat-label>Scenario Category</mat-label>
      <mat-select [(ngModel)]="industryScenario.industryScenarioCategory"
                  formControlName="updatedIndustryScenarioCategory">
        <mat-option *ngFor="let scenarioCategory of scenarioCategories" [value]="scenarioCategory.scenarioCategory">
          {{ scenarioCategory.scenarioCategory }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
      <mat-label>Scenario Type</mat-label>
      <mat-select [(ngModel)]="industryScenario.industryScenarioType" formControlName="updatedIndustryScenarioType">
        <mat-option *ngFor="let scenarioType of scenarioTypes" [value]="scenarioType['SCEN_TYPE']">
          {{ scenarioType["SCEN_TYPE"] }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Enter Scenario Assumption</mat-label>
      <textarea formControlName="updatedScenarioAssumption" matInput rows="1" maxlength="150"
                id="scenario-assumption-input"
                [(ngModel)]="industryScenario.industryScenarioAssumption"
                value="{{ industryScenario.industryScenarioAssumption }}">
    </textarea>
    </mat-form-field>
    <div class="radio-button-group justify-content-center" *ngIf="isAdmin">
      <div id="del-lock-container" class="default-margin">
        <mat-label>Delete Lock:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsDeleteLocked">
          <div *ngIf="industryScenario.isDeleteLocked === true; then selectDeleteLock else selectDeleteUnlock">
          </div>
          <ng-template #selectDeleteLock>
            <div>
              <mat-radio-button checked value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button value=false>OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectDeleteUnlock>
            <div>
              <mat-radio-button value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value=false>OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
      <div id="edit-lock-container" class="default-margin">
        <mat-label>Edit Lock:</mat-label>
        <br/>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsEditLocked">
          <div *ngIf="industryScenario.isEditLocked === true; then selectEditLock else selectEditUnlock">
          </div>
          <ng-template #selectEditLock>
            <div>
              <mat-radio-button checked value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button value="false">OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectEditUnlock>
            <div>
              <mat-radio-button value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value="false">OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
      <div id="hidden-container" class="default-margin">
        <mat-label>Hide Scenario:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsHiddenLocked">
          <div *ngIf="industryScenario.isHidden === true; then selectHiddenLock else selectHiddenUnlock">
          </div>
          <ng-template #selectHiddenLock>
            <div>
              <mat-radio-button checked value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button value=false>OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectHiddenUnlock>
            <div>
              <mat-radio-button value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value=false>OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
    </div>
  </form>
</div>
